import React from 'react'
import styled from 'styled-components'

const Logo = () => {
  return (
    <Svg
      style={{ marginTop: 50 }}
      width="40"
      height="72"
      viewBox="0 0 40 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.1553 38.3965C34.1553 44.3535 32.5114 48.9434 29.2236 52.166C25.9521 55.3887 21.346 57 15.4053 57H3.85742V21.3066H16.2109C21.9401 21.3066 26.359 22.7715 29.4678 25.7012C32.5928 28.6309 34.1553 32.8626 34.1553 38.3965ZM24.1455 38.7383C24.1455 35.4668 23.4945 33.0417 22.1924 31.4629C20.9066 29.8841 18.9453 29.0947 16.3086 29.0947H13.501V49.0898H15.6494C18.5791 49.0898 20.7275 48.2435 22.0947 46.5508C23.4619 44.8418 24.1455 42.2376 24.1455 38.7383Z"
        fill="#FA1313"
      />
      <path
        d="M37.1553 34.3965C37.1553 40.3535 35.5114 44.9434 32.2236 48.166C28.9521 51.3887 24.346 53 18.4053 53H6.85742V17.3066H19.2109C24.9401 17.3066 29.359 18.7715 32.4678 21.7012C35.5928 24.6309 37.1553 28.8626 37.1553 34.3965ZM27.1455 34.7383C27.1455 31.4668 26.4945 29.0417 25.1924 27.4629C23.9066 25.8841 21.9453 25.0947 19.3086 25.0947H16.501V45.0898H18.6494C21.5791 45.0898 23.7275 44.2435 25.0947 42.5508C26.4619 40.8418 27.1455 38.2376 27.1455 34.7383Z"
        fill="#FFF500"
      />
    </Svg>
  )
}

const Svg = styled.svg`
  animation: fadeIn 1500ms 500ms both cubic-bezier(0.075, 0.82, 0.165, 1);

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`

export default Logo
